import React from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import { Visibility } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import { Box } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { currency } from 'hooks/Pipe';
import moment from 'moment';

const columns = [
  { Header: '#', accessor: 'num', width: 50 },
  { Header: 'Id', accessor: 'id', width: 80 },
  { Header: 'Procesado', accessor: 'process', excelEnabled: false, width: 120 },
  { Header: 'Tipo', accessor: 'type', width: 100 },
  { Header: 'Usuario', accessor: 'user', width: 200 },
  { Header: 'Fecha Creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha Contable', accessor: 'DocDate', width: 150 },
  { Header: 'Cód. Socio', accessor: 'CardCode', width: 120 },
  { Header: 'Socio Negocio', accessor: 'CardName' },
  { Header: 'Importe', accessor: 'import', align: 'right', width: 120 },
  { Header: 'Impreso', accessor: 'Printed', align: 'center', width: 120 },
  { Header: 'Comentario', accessor: 'Comments', width: 250 },
  { Header: 'HR', accessor: 'prog_sheet_distribution_id', width: 75 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ClosingReceivedPayments({ data, permission, location }) {
  return (
    <ReactTable
      columns={columns}
      heightRow={50}
      defaultWidth={2000}
      data={data.map((item, i) => {
        return {
          ...item,
          num: (
            <Box display="flex" alignItems="center">
              {i + 1}
              <AllowedGuard permission={permission}>
                <RegularButton justIcon round simple>
                  <Link to={`${location}/${item.id}`}>
                    <Visibility />
                  </Link>
                </RegularButton>
              </AllowedGuard>
            </Box>
          ),
          id: item.id.toString(),
          process: (
            <>
              {item.sapAnnuled !== null ? (
                <Badge color={item.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                  {item.sapAnnuled === 'P' ? 'Proceso anulación' : 'Anulado'}
                </Badge>
              ) : (
                <>
                  {item.DocEntry !== null && <Badge color="success">Si</Badge>}
                  {item.DocEntry === null && parseInt(item.sapCount) === 0 && (
                    <Badge color="warning">Procesando</Badge>
                  )}
                  {item.DocEntry === null && parseInt(item.sapCount) > 0 && (
                    <Badge
                      color="danger"
                      style={{ cursor: 'pointer' }}
                      onClick={() => alert(item.sapError)}
                    >
                      Error!
                    </Badge>
                  )}
                </>
              )}
            </>
          ),
          type:
            item.type === 'CH'
              ? 'Efectivo'
              : item.type === 'TR'
              ? 'Transferencia'
              : item.type === 'CK'
              ? 'Cheque'
              : item.type === 'LT'
              ? 'Letra'
              : '-',
          user: item?.user?.name || '-',
          created_at: moment(item.created_at).format('DD/MM/YYYY'),
          DocDate: moment(item.DocDate).format('DD/MM/YYYY'),
          CardCode: item.CardCode,
          CardName: item.CardName,
          import:
            item.type === 'CH'
              ? currency(item.CashSum)
              : item.type === 'TR'
              ? currency(item.TrsfrSum)
              : item.type === 'CK'
              ? currency(item.CheckSum)
              : item.type === 'LT'
              ? currency(item.CheckSum)
              : '-',
          Printed: item.Printed === 'N' ? 'No' : 'Si',
          Comments: item.Comments,
          prog_sheet_distribution_id: item.prog_sheet_distribution_id,
          actions: '',
        };
      })}
    />
  );
}

export default ClosingReceivedPayments;
